import "./assets/styles/base.css";

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import { initYandexMetrika } from 'yandex-metrika-vue3'

const app = createApp(App)

app.use(createPinia())
app.use(router)

// Настройка vue-yandex-metrika
app.use(initYandexMetrika, {
  id: '100384656', //  !!! ЗАМЕНИТЕ на ВАШ ID счетчика !!!
  router: router,       // Передаем экземпляр Vue Router
  env: 'production',//import.meta.env.MODE, // Используем Vite's environment variables
  options: {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true,
      webvisor: true, // ВАЖНО: Включите вебвизор, если нужно отслеживать действия
  },
  // Дополнительные параметры (необязательно):
  debug: import.meta.env.MODE === 'development', // Включаем режим отладки в development
  ignoreRoutes: [],  // Массив маршрутов, которые не нужно отслеживать
  skipSamePath: true,  // Не отслеживать повторные переходы на ту же страницу
  trackHash: true,   //  Отслеживать переходы по якорям (#)
})



app.mount('#app')